import {ReactNode} from "react";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

/**
 * Option items for a {@link ListInput} component
 */
export interface ListOption {
	label: string;
	value: any;
	disabled?: boolean;
}

/**
 * The properties for a {@link ListInput} component
 */
export interface ListInputProperties {
	inputId?: string;
	disabled?: boolean;
	className?: string;
	style?: React.CSSProperties;
	multiple?: boolean;
	options?: Array<ListOption>;
	tooltip?: string;
	value?: Array<string> | string;
	tabIndex?: number;

	onChange?(e: {
		originalEvent: React.SyntheticEvent;
		value: Array<string>;
	}): void;
}

/**
 * This component wraps a {@link select} element and makes it customizable
 */
export default class ListInput extends PortalPureComponent<ListInputProperties, any> {
	/**
	 * Constructs a {@link ListInput} component
	 */
	constructor(props: Readonly<ListInputProperties>) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	/**
	 * Called when the input value changes and calls the given onChange function from props
	 */
	private onChange(event: any): void {
		if (!FunctionHelper.exists(this.props.onChange)) {
			return;
		}

		let value: Array<string> = [];

		if (this.props.multiple) {
			let options: Array<any> = event.target.options;
			for (let option of options) {
				if (option.selected) {
					value.push(option.value);
				}
			}
		} else if (FunctionHelper.exists(event.target.value)) {
			value.push(event.target.value);
		}

		this.props.onChange!({
			originalEvent: event,
			value: value
		});
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let value: Array<string> = [];
		if (typeof this.props.value === "string") {
			value.push(this.props.value);
		} else if (FunctionHelper.exists(this.props.value)) {
			value = this.props.value!;
		}

		let options: Array<ReactNode> = [];
		for (let option of FunctionHelper.applyValue(this.props.options, [])) {
			options.push(
				<option key={options.length} value={option.value} disabled={option.disabled}>
					{option.label}
				</option>
			);
		}

		return (
			<>
				<div className="input-list tooltip" data-pr-tooltip={this.props.tooltip}>
					<select {...this.props} id={this.props.inputId} multiple={true} onChange={this.onChange}
							value={value}>
						{options}
					</select>
				</div>
			</>
		);
	}
}